import { connect } from 'react-redux';

import GridTileInnerTypeForm from './form.jsx';

import { submitForm } from 'zoomforth_codesbane_viewer/action_creators/viewer.js';
import { makeRandomAlphaNumeric } from 'zoomforth_zfutils/random.js';

export const mapStateToProps = () => {
  return {
    uniqueFormString: `random_${makeRandomAlphaNumeric(5)}`
  };
};

export const mapDispatchToProps = (dispatch, { asset, pageId, contentUuid, onSuccess, onError }) => ({
  onFormSubmit: (responseData, options = {}) => {
    dispatch(submitForm({
      responseData,
      pageId,
      formId: asset.id,
      contentUuid,
      onSuccess: options.onSuccess,
      onError: options.onError
    }));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GridTileInnerTypeForm);
